import Stepper from "react-stepper-horizontal";
import EmployeeDetails from "../components/EmployeeDetails";
import GoldPayment from "../components/GoldPayment";
import ErrorMessage from "../components/ErrorMessage";
import { useEffect, useState } from "react";
import { notify } from "react-notify-toast";
import axios from "axios";
import config from "../config";
import Confirmation from "../components/Confirmation";
import ClevertapReact from 'clevertap-react';


export default function Signup({ setLoading }) {
    ClevertapReact.event("User landed on Sign Up Page")
    const [formData, setFormData] = useState({});
    const [stepperValue, setStepperValue] = useState(0);
    const [packageDetails, setPackageDetails] = useState({})

    async function setFormState(data) {
        setFormData({
            ...formData,
            ...data,
        });
    }

    useEffect(() => {
        (async function () {
            if (stepperValue === 0 && Object.keys(formData).length > 0) {
                await parterDetailsApi(formData);
            }
        })()
    }, [formData]);

    function displayRazorPay(data) {
        let options = {
            key: config.razorpayKey, // Enter the Key ID generated from the Dashboard
            amount: data.amount.toString(), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "MediBuddy",
            description: "MediBuddy Gold Activation",
            image: "https://sme-ui.s3.ap-south-1.amazonaws.com/MBLOGO.png",
            order_id: data.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            handler: async function (response) {
                let payload = {
                    paymentLink: response.razorpay_payment_id,
                    amount: data.amount,
                };
                let result = await axios.post(
                    config.apiUrl + "smeCorporate/paymentCapture",
                    payload
                );
                if (result.data.capture) {
                    setStepperValue(2);
                }
            }
            ,
            prefill: {
                name: formData.Name,
                email: formData.Email,
                contact: formData.MobileNumber,
            },
        };
        try {
            let rzp1 = new window.Razorpay(options);
            rzp1.open();
        } catch (e) {
            notify.show(<ErrorMessage />)
        }

    }

    async function submitPackageAndFile(data) {
        try {
            ClevertapReact.event("Clicked next on Pay Now, Step 2 Sign Up Page")
            let payload = new FormData()
            payload.append('attachment', data.file[0])
            payload.append('CompanyName', formData.CompanyName)
            payload.append('amount', data.amount)
            payload.append('Email', formData.Email)
            payload.append('MobileNumber', data.amount)
            payload.append('packageId', data.packageId)
            const res = await axios.post(config.apiUrl + 'smeCorporate/paymentLinkGeneration', payload, {
                headers: { "Content-Type": "multipart/form-data" }
            })
            if (res.data.response && res.data.response.isSuccess && res.data.response.paymentLink && res.data.response.paymentLink.id) {
                try {
                    console.log(111);
                    displayRazorPay({
                        orderId: res.data.response.paymentLink.id,
                        amount: res.data.response.paymentLink.amount,
                    })
                } catch (error) {
                    console.log(error)
                    notify.show(<ErrorMessage />)
                }

            } else {
                if (res.data.response.message) {
                    notify.show(<ErrorMessage message={res.data.response.message} />)
                } else {
                    notify.show(<ErrorMessage />)
                }
            }
        } catch (error) {
            console.log(error)
            notify.show(<ErrorMessage />)
        }
    }

    async function parterDetailsApi(values) {
        try {
            const formPayload = {
                Name: values.Name,
                Email: values.Email,
                MobileNumber: values.MobileNumber,
                Role: values.Role ? values.Role : "",
                Address: values.Address ? values.Address : "",
                Pincode: values.Pincode ? values.Pincode : "",
                EmployeeID: values.CompanyName ? values.CompanyName : "",
                CompanyWebsiteUrl: values.CompanyUrl ? values.CompanyUrl : "",
                EmployeeCount: values.EmpCount ? values.EmpCount : 0,
                from: 2
            };
            setLoading(true);
            const response = await axios.post(
                config.apiUrl + "smeCorporate/leadGeneration",
                formPayload
            );
            setLoading(false);
            if (response.data.isSuccess) {
                await getPackages()
            } else {
                notify.show(<ErrorMessage />);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            notify.show(<ErrorMessage />);
        }
    }

    async function getPackages() {
        try {
            setLoading(true);
            const payload = { serviceType: 1 };
            const response = await axios.post(
                config.apiUrl + "smeCorporate/getPackageDetails",
                payload
            );
            setLoading(false);
            if (response.data.isSuccess && response.data.packagedetails.length > 0) {
                const packageObj = {}
                response.data.packagedetails.forEach(data => {
                    packageObj[data.duration] = { amount: data.amount, packageId: data.packageId }
                })
                setPackageDetails(packageObj)
                setStepperValue(2);
            } else {
                notify.show(<ErrorMessage />);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            notify.show(<ErrorMessage />);
        }
    }

    return (
        <div className="mx-5 md:mx-36">
            <div className="font-black md:mx-10 text-3xl mt-10">
                Just few steps away to Employee Happiness...
            </div>
            <Stepper
                steps={[
                    { title: "Employee Details" },
                    // { title: "Payment" },
                    { title: "Confirmed" },
                ]}
                activeStep={stepperValue}
                stepClassName="blue-bg"
            />
            {stepperValue === 0 ? (
                <EmployeeDetails
                    stepperStateValue={setStepperValue}
                    setFormData={setFormState}
                />
            ) : null}
            {stepperValue === 1 ? (
                <GoldPayment
                    packageDetails={packageDetails}
                    stepperStateValue={setStepperValue}
                    setFormData={setFormState}
                    submitPackageAndFile={submitPackageAndFile}
                />
            ) : null}
            {stepperValue === 2 ? (
                <Confirmation />
            ) : null}
        </div>
    );
}
